interface Step {
  number: number
  title: string
  description: string
  emoji: string
}

const steps: Step[] = [
  {
    number: 1,
    emoji: '👋',
    title: 'Share Preferences',
    description: 'Tell us about dietary needs, cooking style, and what you love',
  },
  {
    number: 2,
    emoji: '🤖',
    title: 'Chat with AI Chef',
    description: 'Get personalized meal suggestions through natural conversation',
  },
  {
    number: 3,
    emoji: '📅',
    title: 'Schedule & Organize',
    description: 'Drag meals onto your calendar for the perfect week',
  },
  {
    number: 4,
    emoji: '🛒',
    title: 'Shop with One Click',
    description: 'Send your grocery list to Instacart and get cooking!',
  },
]

export function HowItWorks() {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-deep-charcoal mb-4">
            How It Works
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            From preference to plate in four simple steps
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line (hidden on mobile, shown on desktop between steps) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-6 left-full w-full h-0.5 bg-gradient-to-r from-toast-gold to-transparent -ml-4" />
              )}

              {/* Step Card */}
              <div className="text-center relative z-10">
                {/* Step Number */}
                <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-toast-gold to-toast-gold-700 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-xl md:text-2xl shadow-md">
                  {step.number}
                </div>

                {/* Emoji */}
                <div className="text-4xl md:text-5xl mb-3">
                  <span role="img" aria-label={step.title}>{step.emoji}</span>
                </div>

                {/* Title */}
                <h3 className="text-xl md:text-2xl font-semibold mb-2 text-deep-charcoal">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 md:mt-16">
          <a
            href="#features"
            className="inline-block text-toast-gold-700 hover:text-toast-gold-800 font-semibold text-lg transition-colors"
          >
            See it in action &rarr;
          </a>
        </div>
      </div>
    </section>
  )
}
